//import { ASSET_URLS } from '@/constants/assetUrls';
import { Box, Flex, Image } from '@everlywell/ui-kit';
import React from 'react';

interface ShareButtonsProps {
  url: string;
  title: string;
  iconSrc?: string;
}

/**
 * ShareButtons component for social media sharing
 * Provides buttons to share content on various social media platforms
 */
const ShareButtons: React.FC<ShareButtonsProps> = ({ url, title, iconSrc }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareUrls = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    email: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
  };

  const handleShare =
    (platform: keyof typeof shareUrls) => (e: React.MouseEvent) => {
      e.preventDefault();
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    };

  return (
    <Flex alignItems="center">
      <Box
        as="button"
        aria-label="Share this article"
        onClick={() => {
          // Toggle dropdown or open share dialog
          if (navigator.share) {
            navigator
              .share({
                title,
                url,
              })
              .catch(() => {
                // Fallback to traditional sharing if Web Share API fails
                handleShare('twitter')({} as React.MouseEvent);
              });
          } else {
            // Fallback for browsers that don't support Web Share API
            handleShare('twitter')({} as React.MouseEvent);
          }
        }}
      >
        <Image src={iconSrc} alt="Share" width="115px" height="40px" />
      </Box>
    </Flex>
  );
};

export default ShareButtons;
